import { Field, Form, Formik } from "formik";
import moment from "moment";
import { useEffect, useState } from "react";
import { useApi } from "../../context/ApiProvider";
import ActivityIndicator from "../Helpers/ActivityIndicator";
import Card from "../Helpers/Card";
import { Link } from "react-router-dom";

export default function Administrators() {

  const Api = useApi();
  const [administrators, setAdministrators] = useState(false);
  const [removeAdministratorError, setRemoveAdministratorError] = useState(false);
  const [removeAdministratorSuccess, setRemoveAdministratorSuccess] = useState(false);
  const [createAdministratorError, setCreateAdministratorError] = useState(false);
  const [createAdministratorSuccess, setCreateAdministratorSuccess] = useState(false);
  const [generatePasswordError, setGeneratePasswordError] = useState(false);
  const [generatePasswordSuccess, setGeneratePasswordSuccess] = useState(false);
  const [allClients, setAllClients] = useState(false);
  const [sort, setSort] = useState({ field: '', order: 'asc' }); //För att kunna sortera
  const [search, setSearch] = useState(''); //Till sökfältet
  const [isLoadingAdministrators, setIsLoadingAdministrators] = useState(false);



  useEffect(() => {
    refresh()
  }, [])


  const refresh = () => {
    fetchAdministrators();
    fetchAllClients();
  }

  const fetchAdministrators = async () => {
    setIsLoadingAdministrators(true);
    Api.get(`/rolf/administrators`).then(data => {
      setAdministrators(data);
    }).catch(() => {
      setAdministrators([]);
    })
    .finally(() => {
      setIsLoadingAdministrators(false);
      setSort({ field: 'name', order: 'asc' })
    })
  }

  const fetchAllClients = async () => {
    Api.get('/rolf/clients')
    .then((data) => {
      setAllClients(data);
    })
    .catch(() => {});
  }

  const createAdministrator = async (values) => {
    setCreateAdministratorError(false);
    setCreateAdministratorSuccess(false);
    return Api.post(`/rolf/administrators`, values).then(data => {
      setCreateAdministratorSuccess('Administrator created');
      return true;
    }).catch(e => {
      setCreateAdministratorError(e.error);
      return false;
    }).finally(() => {
      setTimeout(() => {
        setCreateAdministratorError(false);
        setCreateAdministratorSuccess(false);
      }, 3000)
    })
  }

  const removeAdministrator = async (id) => {

    setRemoveAdministratorError(false);
    setRemoveAdministratorSuccess(false);
    if (!window.confirm('Are you sure you wish to remove this administrator from Rolf?'))
      return;
    await Api.delete(`/rolf/administrators/${id}`).then(data => {
      refresh();
      setRemoveAdministratorSuccess('Administrator removed');
    }).catch(e => {
      setRemoveAdministratorError(e.error);
    }).finally(() => {
      setTimeout(() => {
        setRemoveAdministratorError(false);
        setRemoveAdministratorSuccess(false);
      }, 3000)
    })
  }

  const generatePassword = async (administratorId) => {
    setGeneratePasswordError(false);
    setGeneratePasswordSuccess(false);
    if (!window.confirm('Are you sure you wish to reset this administrators password?'))
      return;
    await Api.post(`/rolf/administrators/${administratorId}/generatepassword`).then(data => {
      setGeneratePasswordSuccess('Password generated successfully');
      return true;
    }).catch(e => {
      setGeneratePasswordError(e.error);
      return false;
    }).finally(() => {
      setTimeout(() => {
        setGeneratePasswordSuccess(false);
        setGeneratePasswordError(false);
      }, 3000);
    })
  }

  useEffect(() => {
    if (!administrators)
      return;
    const field = sort.field;

    const sortedAdministrators = [...administrators].sort((a, b) => {
      if (field === 'lastLogin' || field === 'clients' || field === 'email') {
        if (a[field] < b[field])
          return sort.order === 'asc' ? -1 : 1;
        if (a[field] > b[field])
          return sort.order === 'asc' ? 1 : -1;
        return 0;
      }
      
      
      if (field === 'name') {
        let aa, bb;
        aa = (a['firstName'] + ' ' + a['lastName']).toLowerCase()
        bb = (b['firstName'] + ' ' + b['lastName']).toLowerCase()
        if (aa < bb) {
          return sort.order === 'asc' ? -1 : 1;
        }
        if (aa > bb) {
          return sort.order === 'asc' ? 1 : -1;
        }
        return 0;
 
      }
    });
    setAdministrators(sortedAdministrators);
  }, [sort]);

  const sortAdministrators = (field) => {
    setSort((prev) => ({ field, order: prev.field === field ? prev.order === 'asc' ? 'desc' : 'asc' : 'asc' }));
  }

  const searchCallback = (administrator) => {
    if (search === '')
      return administrator;

    const searchValue = search.toLowerCase();

    if (administrator.firstName.toLowerCase().includes(searchValue))
      return administrator;

    if (administrator.lastName.toLowerCase().includes(searchValue))
      return administrator;
    if (administrator.email && administrator.email.toLowerCase().includes(searchValue))
      return administrator;
  }

  return (
    <div className="grid-container">
      <>
      <section>
        <h4>Administrators</h4>
        
        {removeAdministratorError ? <div className="formControlError">{removeAdministratorError}</div> : ""}
        {removeAdministratorSuccess ? <div className="formControlSuccess">{removeAdministratorSuccess}</div> : ""}
        {generatePasswordError ? <div className="formControlError">{generatePasswordError}</div> : ""}
        {generatePasswordSuccess   ? <div className="formControlSuccess">{generatePasswordSuccess}</div> : ""}

        <label>Search Administrator</label>
        <input type="search" placeholder="Search administrators by name or email" size={30} onChange={(e) => { setSearch(e.target.value) }} className="formControl" />

        {isLoadingAdministrators && <p>Loading administrators...</p>}

        {administrators && administrators.length > 0 ?
        <>
        <p className="meta">
          Click headers to toggle sort order
        </p>

        <table>
          <thead>
            <tr>
              <th onClick={() => sortAdministrators("name") } title="The name of the administrator. Click the name to edit the administrator">Name {sort.field === 'name' ? sort.order === 'asc' ? '▲' : '▼' : null}</th>
              <th onClick={() => sortAdministrators("email") } title="The email adress of the administrator">Email {sort.field === 'email' ? sort.order === 'asc' ? '▲' : '▼' : null}</th>
              <th onClick={() => sortAdministrators("clients") } title="Number of clients that the administrator is connected to">Clients {sort.field === 'clients' ? sort.order === 'asc' ? '▲' : '▼' : null}</th>
              <th onClick={() => sortAdministrators("lastLogin") } title="How long ago the administrator logged in">Last login {sort.field === 'lastLogin' ? sort.order === 'asc' ? '▲' : '▼' : null}</th>
              <th title="Whether the administrator is a super administrator who has access to all clients">Superadmin</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {administrators?.filter(searchCallback).map((admin, index) => (
              <tr key={index}>
                <td><Link to={`./${admin.ID}`} title="Click on the name to edit the administrator.">{admin.firstName} {admin.lastName}</Link> </td>
                <td>{admin.email}</td>
                <td>{admin.clients}</td>
                <td>{admin.lastLogin ? moment.unix(admin.lastLogin).fromNow() : 'Never'}</td>
                <td>{admin.rolf ? 'Yes' : 'No'}</td> 
                <td>
                    <a onClick={() => generatePassword(admin.ID)}>Reset password</a>
                </td>
                <td>
                {admin.rolf ? null :
                  <a onClick={() => removeAdministrator(admin.ID)}>Remove</a>
                }
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </>
        : null }
      </section>
      <section>
        <h4>Create administrator</h4>
        <Card>
          <Formik
            initialValues={{ firstName: '', lastName: '', email: '', clientId: '', rolf: "0" }}
            enableReinitialize={true}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              if(values.rolf === "1") {
                values = {...values, clientId: ''}
              }
              
              createAdministrator(values).then((result) => {
                setSubmitting(false);

                refresh();
                if (result)
                  resetForm();
              })
            }}>
            {({ isSubmitting, values }) => (
              <Form>
                {createAdministratorError && <div className="formControlError">{createAdministratorError}</div>}
                {createAdministratorSuccess && <div className="formControlSuccess">{createAdministratorSuccess}</div>}
                <label htmlFor="firstName">First name</label>
                <Field type="text" id="firstName" name="firstName" className="formControl" required />
                <label htmlFor="lastName">Last name</label>
                <Field type="text" id="lastName" name="lastName" className="formControl" required />
                <label htmlFor="email" >Email</label>
                <Field type="email" id="email" name="email" className="formControl" required />
                <label htmlFor="rolf">Superadmin (has access to all clients)</label>
                <Field as="select" id="rolf" name="rolf" className="formControl"  required>
                  <option value="0">No</option>
                  <option value="1">Yes</option>
                </Field>
                <label htmlFor="clientId">Connect to client</label>
                <Field as="select" id="clientId" name="clientId" className="formControl" disabled={values.rolf !== "0" ? true : false}>
                    <option value="">Do not connect to any client</option>
                    {values.rolf === "0" && allClients && allClients.map((c) => {
                      return(<option key={c.ID} value={c.ID}>{c.name}</option>);
                    })}
                </Field>
                <button type="submit" disabled={isSubmitting}>Create administrator {isSubmitting && <ActivityIndicator />}</button>
              </Form>
            )}
          </Formik>
        </Card>
      </section> 
      </>

    </div>
    )
}
